import React from 'react';
import { ESRD, HH, IPPS, LTCH, OPPS, PFS, PSYCH, REHAB, SNF, FQHC } from '../../../Constants/modelTypes';
import { ResultValue } from '../../Simple';
import { format } from "date-fns";
import { API_DATE_STRING_FORMAT } from '../../../Constants/stringFormats';
import { PROVIDER_NAME_NOT_FOUND } from '../../../Constants/defaults';

export default function BasicInformation(props) {
    const currentDateStamp = format(props.processedDate, API_DATE_STRING_FORMAT);
    if (props.model === IPPS) {
        const currentFiscalQuarter = new Date();
        currentFiscalQuarter.setDate(1);
        currentFiscalQuarter.setMonth(currentFiscalQuarter.getMonth() + 3);
        // If the fiscal quarter does not match the current fiscal quarter
        const showAsOfDate = props.dataFiscalQuarter !== String(currentFiscalQuarter.getFullYear()) + String(Math.floor(currentFiscalQuarter.getMonth() / 3) + 1);
        // Expected dataFiscalQuarter format === {as of date year} + {quarter}, Ex: 20241, from useFYPricingAsOfQuarter hook
        const fiscalQuarter = Number(props.dataFiscalQuarter.slice(-1));
        const fiscalYear = Number(props.dataFiscalQuarter.slice(0, -1));
        let asOfDateLabel;
        if (fiscalQuarter === 1) {
            // Take away one to go into the previous year
            // Make it Q4 (2023 to 2023Q4)
            // Remember the calendar quarters lag behind the fiscal quarters
            // Q1 2024 = Q4 2023, Q2 2024 = Q1 2024, etc
            asOfDateLabel = fiscalYear - 1 + "Q4";
        } else {
            // Make quarter one less (2024Q2 to 2024Q1)
            // Remember the calendar quarters lag behind the fiscal quarters
            // Q1 2024 = Q4 2023, Q2 2024 = Q1 2024, etc
            asOfDateLabel = fiscalYear + "Q" + (fiscalQuarter - 1);
        }

        return (<>
            <h4>Basic Information</h4>
            <ResultValue label="Medicare Pricer Fiscal Year" value={props.fiscalYear} />
            <ResultValue label="Pricing Mode" value="FFS Medicare" />
            <ResultValue label="Claim ID" value={props.result.claimID} />
            <ResultValue label="Provider Name" value={props.result.providerName} />
            <ResultValue label="Medicare ID" value={props.result.medicareID} />
            <ResultValue label="PSF Effective Date" value={props.result.psfEffectiveDate} />
            <ResultValue label="Claim Priced Date" value={format(new Date(), API_DATE_STRING_FORMAT)} />
            {showAsOfDate && <ResultValue label="Pricing Data 'As-Of' Date" value={asOfDateLabel} />}
        </>);
    }

    if (props.model === PSYCH || props.model === REHAB || props.model === LTCH) {
        return (<>
            <h4>Basic Information</h4>
            <ResultValue label="Pricing Mode" value="FFS Medicare" />
            <ResultValue label="Pricing Fiscal Year" value={props.fiscalYear} />
            <ResultValue label="Claim ID" value={props.result.claimID} />
            <ResultValue label="Provider Name" value={props.result.providerName} />
            <ResultValue label="Medicare ID" value={props.result.medicareID} />
            <ResultValue label="PSF Effective Date" value={props.result.psfEffectiveDate} />
            <ResultValue label="Claim Priced Date" value={currentDateStamp} />
        </>);
    }

    if (props.model === SNF) {
        return (<>
            <h4>Basic Information</h4>
            <ResultValue label="Pricing Mode" value="FFS Medicare" />
            <ResultValue label="Pricing Fiscal Year" value={props.fiscalYear} />
            <ResultValue label="Claim ID" value={props.result.claimID} />
            <ResultValue label="Provider Name" value={props.result.providerName} />
            <ResultValue label="Medicare ID" value={props.result.medicareID} />
            <ResultValue label="Claim Priced Date" value={currentDateStamp} />
        </>);
    }

    if (props.model === HH) {
        return (<>
            <h4>Basic Information</h4>
            <ResultValue label="Pricing Mode" value="FFS Medicare" />
            <ResultValue label="Pricing Calendar Year" value={props.calendarYear} />
            <ResultValue label="Claim ID" value={props.result.claimID} />
            <ResultValue label="Provider Name" value={props.result.providerName === PROVIDER_NAME_NOT_FOUND && props.inputProviderName ? props.inputProviderName : props.result.providerName} />
            <ResultValue label="Medicare ID" value={props.result.medicareID} />
            <ResultValue label="PSF Effective Date" value={props.result.psfEffectiveDate} />
            <ResultValue label="Claim Priced Date" value={currentDateStamp} />
        </>);
    }

    if (props.model === OPPS) {
        return (<>
            <h4>Basic Information</h4>
            <ResultValue label="Pricing Mode" value="FFS Medicare" />
            <ResultValue label="Pricing Calendar Year" value={props.calendarYear} />
            <ResultValue label="Claim ID" value={props.result.claimID} />
            <ResultValue label="Provider Name" value={props.result.providerName} />
            <ResultValue label="Medicare ID" value={props.result.medicareID} />
            <ResultValue label="ZIP Code" value={props.result.zipCode} />
            <ResultValue label="Claim Priced Date" value={currentDateStamp} />
        </>);
    }

    if (props.model === PFS) {
        return (<>
            <h4>Basic Information</h4>
            <ResultValue label="Pricing Mode" value="FFS Medicare" />
            <ResultValue label="Pricing Calendar Year" value={props.calendarYear} />
            <ResultValue label="Claim ID" value={props.result.claimID} />
            <ResultValue label="Provider NPI" value={props.result.providerName} />
            <ResultValue label="Service Facility ZIP Code" value={props.result.zipCode} />
            <ResultValue label="Claim Priced Date" value={currentDateStamp} />
        </>);
    }

    if (props.model === ESRD) {
        return (<>
            <h4>Basic Information</h4>
            <ResultValue label="Pricing Mode" value="FFS Medicare" />
            <ResultValue label="Pricing Calendar Year" value={props.calendarYear} />
            <ResultValue label="Claim ID" value={props.result.claimID} />
            <ResultValue label="Provider Name" value={props.result.providerName} />
            <ResultValue label="Medicare ID" value={props.result.medicareID} />
            <ResultValue label="NPI" value={props.result.npi} />
            <ResultValue label="ZIP Code" value={props.result.zipCode} />
            <ResultValue label="Claim Priced Date" value={currentDateStamp} />
        </>);
    }

    if (props.model === FQHC) {
        return (<>
            <h4>Basic Information</h4>
            <ResultValue label="Pricing Mode" value="FFS Medicare" />
            <ResultValue label="Pricing Calendar Year" value={props.calendarYear} />
            <ResultValue label="Claim ID" value={props.result.claimId} />
            <ResultValue label="Medicare ID" value={props.result.medicareId} />
            <ResultValue label="Provider ZIP Code" value={props.result.providerZip} />
            <ResultValue label="Claim Priced Date" value={currentDateStamp} />
        </>);
    }

    console.warn('Model unknown:', props.model);
    return null;
}
